import { useRef, useState } from "react"
import Form, { useForm } from "../../gui/Form/Form"
import FormControl from "../../gui/Form/FormControl"
import Validators from "../../gui/Form/Validators"
import { useOverlay } from "../../gui/Overlay/OverlayProvider"
import TextInput, { ITextInput } from "../../gui/TextInput/TextInput"
import DialogTitle from "../Dialogs/DialogTitle"
import Button from "../../gui/Button/Button"
import MealsCache from "../../data/MealsCache"
import { useSnackbar } from "../../gui/Snackbar/SnackbarProvider"

function AddMealDlg(){
    const [busy,setBusy] = useState<boolean>(false)
    const refName = useRef<ITextInput|null>(null)
    const {valid} = useForm()
    const {addSnackbar} = useSnackbar()
    const {popOverlay} = useOverlay()
    const onClose = () => popOverlay("addMeal")
    const onSave = async () => {
        if (busy || !refName.current?.value) return
        else setBusy(true)
        try {
            await MealsCache.i.addMeal(refName.current.value)
            popOverlay("addMea")
        }catch(e){
            addSnackbar(e)
        }
    }
    return <>
        <DialogTitle title="Add Meal" onClose={onClose}/>
        <div className="content">
            <FormControl validators={[Validators.Required("Name")]}><TextInput ref={refName} placeholder="Name" float={true}/></FormControl>
        </div>
        <div className="actions">
            <Button variant="text" size="regular" onClick={onClose}>CANCEL</Button>
            <Button variant="contained" size="regular" color="primary" onClick={onSave} disabled={busy||!valid}>SAVE</Button>
        </div>
    </>
}

export default function useAddMeal(){
    const {addOverlay} = useOverlay()
    const addMeal = () => addOverlay("addMeal", {children:<Form><AddMealDlg/></Form>, className:"dialog popup"})
    return {addMeal}
}